import {ErrorInterfaceGenqlSelection} from "@/gql/gen";

export const ErrorFields: ErrorInterfaceGenqlSelection = {
    type: true,
    name: true,
    rel: true,
    message: true,
    messages: true,
    alertShow: true,
    alertMessage: true,
    targetShow: true,
    targetMessage: true,
    debug: true,
    on_RateError: {
        ttl: true,
    },
    on_AccessError: {
        authRedirect: true,
    },
    on_FormError: {
        fieldLabel: true,
        fieldName: true,
    },
};
